webpackJsonp([1],{

/***/ 1057:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1058:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1059:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1060:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1061:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1062:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1063:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1064:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1065:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1066:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1067:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1070:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1071:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1072:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1073:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1074:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1075:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1076:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1241:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1242:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1243:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1244:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cmf-cropped.b8de43e.png";

/***/ }),

/***/ 1246:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1247:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1248:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1250:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 1251:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1252:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_DOAJC_cropped.0f2f3c7.png";

/***/ }),

/***/ 1253:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logos_intro_DOAJC_montage.6f5dad2.png";

/***/ }),

/***/ 1255:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1075)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(782),
  /* template */
  __webpack_require__(1288),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1256:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1062)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(783),
  /* template */
  __webpack_require__(1275),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-091500e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1257:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1064)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(784),
  /* template */
  __webpack_require__(1277),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-142e3212",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1258:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1066)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(785),
  /* template */
  __webpack_require__(1279),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36ce5d55",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1259:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1063)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(786),
  /* template */
  __webpack_require__(1276),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a8791bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1260:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1076)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(787),
  /* template */
  __webpack_require__(1289),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1061)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(788),
  /* template */
  __webpack_require__(1274),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0798cd6e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1070)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(789),
  /* template */
  __webpack_require__(1283),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51f68cef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(790),
  /* template */
  __webpack_require__(1272),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1264:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1060)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(791),
  /* template */
  __webpack_require__(1273),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(792),
  /* template */
  __webpack_require__(1286),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7cd2b608",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1067)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(793),
  /* template */
  __webpack_require__(1280),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d617825",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1267:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1072)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(794),
  /* template */
  __webpack_require__(1285),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7095a392",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1268:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1069)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(795),
  /* template */
  __webpack_require__(1282),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a8c9008",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1269:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1071)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(796),
  /* template */
  __webpack_require__(1284),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1270:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(1278),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1271:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1068)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(1281),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3e1379d1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', {
    staticClass: "overflow-x-hidden",
    attrs: {
      "home": true
    }
  }, [_c('div', {
    staticClass: "home flex-inline justify-between"
  }, [_c('div', {
    staticClass: "logointro"
  }, [_c('img', {
    staticClass: "logointro2",
    attrs: {
      "src": __webpack_require__(1253)
    }
  })]), _c('div', {
    staticClass: "soustitreintro mb1 ph2"
  }, [_c('h1', [_vm._v("The amazing story of a group of jewish songwriters who wrote the soundtrack to christmas")])]), _c('div', {
    staticClass: "enterbouton pb5 pt1"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'hello'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1251),
      "width": "100px"
    }
  })])], 1), _c('div', {
    staticClass: "bandeauinfos pt2 pb3 shadow-up-4"
  }, [(_vm.date_de_diffusion.length > 0) ? _c('q-carousel', {
    staticClass: "text-white",
    attrs: {
      "infinite": "",
      "autoplay": ""
    }
  }, _vm._l((_vm.date_de_diffusion[0].page_containers), function(date) {
    return _c('div', {
      staticClass: "sliderstyle2",
      slot: "slide"
    }, [_c('div', {
      staticClass: "w-100 flex-inline"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(date.container.description)
      }
    }), (date.container.medias.length > 0) ? _c('div', {
      staticClass: "images"
    }, [_c('img', {
      staticClass: "pl2",
      attrs: {
        "src": date.container.medias[0].image.url
      }
    })]) : _vm._e()])])
  })) : _vm._e()], 1), _c('q-carousel', {
    staticClass: "carousellogos text-white",
    attrs: {
      "infinite": "",
      "autoplay": ""
    }
  }, [_c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1244),
      "width": "85px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1249),
      "width": "100px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1246),
      "width": "120px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1243),
      "width": "100px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1248),
      "width": "150px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1250),
      "width": "50px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1241),
      "width": "70px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1247),
      "width": "80px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1242),
      "width": "60px;"
    }
  })])]), _c('div', {
    staticClass: "sliderstyle",
    slot: "slide"
  }, [_c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1245),
      "width": "200px;"
    }
  })])])])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1273:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [(_vm.from === 'film') ? _c('div', {
    staticClass: "backgroundtexturefilm"
  }) : _c('div', {
    staticClass: "backgroundtexture"
  }), (_vm.container) ? _c('div', {
    staticClass: "info-show"
  }, [_c('q-btn', {
    directives: [{
      name: "back-to-top",
      rawName: "v-back-to-top.animate",
      value: ({
        offset: 500,
        duration: 200
      }),
      expression: "{offset: 500, duration: 200}",
      modifiers: {
        "animate": true
      }
    }],
    staticClass: "fixed-bottom-right animate-pop",
    staticStyle: {
      "margin": "0 30px 30px 0"
    },
    attrs: {
      "round": "",
      "color": "negative"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up fa-2x white"
  })]), _c('div', {
    staticClass: "bloctitre"
  }, [_vm._v(_vm._s(_vm.container.titre))]), _vm._l((_vm.container.medias), function(med) {
    return _c('div', {
      staticClass: "soustitre"
    }, [(med.image) ? _c('div', {
      staticClass: "conteneurimages"
    }, [_c('img', {
      staticClass: "mb1",
      attrs: {
        "src": med.image.thumbnail
      }
    }), _c('p', {
      domProps: {
        "innerHTML": _vm._s(med.image.description)
      }
    })]) : _vm._e()])
  }), _vm._l((_vm.container.medias), function(med) {
    return (_vm.from === true) ? _c('div', {
      staticClass: "soustitre"
    }, [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.valvid)
      }
    })]) : _c('div', [_c('q-video', {
      staticStyle: {
        "height": "300px"
      },
      attrs: {
        "src": _vm.getVid(med.video.link)
      }
    }), _c('p', {
      staticClass: "mt2"
    }, [_vm._v(_vm._s(med.video.titre))])], 1)]) : _vm._e(), _c('div', {
      staticClass: "blocdescription",
      domProps: {
        "innerHTML": _vm._s(_vm.container.description)
      }
    })]) : _c('div', {
      staticClass: "blocdescription"
    }, [(_vm.container.medias[0].video && _vm.container.medias[0].video.titre === 'DoaJC Teaser') ? _c('div', _vm._l((_vm.container.medias), function(med) {
      return _c('div', {
        staticClass: "soustitre"
      }, [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.valvid)
        }
      })]) : _c('div', [_c('q-video', {
        staticStyle: {
          "height": "300px"
        },
        attrs: {
          "src": _vm.getVid(med.video.link)
        }
      }), _c('p', {
        staticClass: "mt2"
      }, [_vm._v(_vm._s(med.video.titre))])], 1)]) : _vm._e()])
    })) : _vm._e(), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.container.description)
      }
    }, _vm._l((_vm.container.medias), function(med) {
      return _c('div', {
        staticClass: "soustitre"
      }, [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.valvid)
        }
      })]) : _c('div', [_c('q-video', {
        staticStyle: {
          "height": "300px"
        },
        attrs: {
          "src": _vm.getVid(med.video.link)
        }
      }), _c('p', {
        staticClass: "mt2"
      }, [_vm._v(_vm._s(med.video.titre))])], 1)]) : _vm._e()])
    }))])
  })], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1274:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "backgroundcolor"
  }), _c('div', {
    staticClass: "interview"
  }, [_c('q-modal', {
    ref: "minimezedModal",
    attrs: {
      "minimized": "minimized",
      "content-css": {
        padding: '-1px',
        background: 'transparent',
        width: '90%'
      }
    }
  }, [(_vm.isVimeo(_vm.inter)) ? _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.valvid)
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "logosection"
  }, [_c('div', {
    staticClass: "sectiontitre"
  }, [_c('span', {
    staticClass: "titretestintro"
  }, [_vm._v("THE "), _c('br')]), _c('span', {
    staticClass: "titretest"
  }, [_vm._v("INTERVIEWS")]), _c('hr', {
    staticClass: "lignemenu"
  })])]), _c('div', {
    staticClass: "contentsection"
  }, _vm._l((_vm.page.page_containers), function(p, index) {
    return ((index >= _vm.minListe() && index <= _vm.maxListe())) ? _c('div', {
      staticClass: "menucontent fl flex"
    }, [_c('div', {
      staticClass: "menustyle2"
    }, [_c('div', {
      staticClass: "white pointer",
      on: {
        "click": function($event) {
          _vm.test(p)
        }
      }
    }, [_vm._v(_vm._s(p.container.titre))])])]) : _vm._e()
  }))], 1), _c('div', {
    staticClass: "conteneurboutons"
  }, [(_vm.isMore) ? _c('q-btn', {
    staticClass: "boutonnext fr absolute",
    attrs: {
      "icon-right": "fa-caret-right"
    },
    on: {
      "click": _vm.showMore
    }
  }, [_vm._v("Next")]) : _vm._e(), (_vm.isLess) ? _c('q-btn', {
    staticClass: "boutonlast fr absolute",
    attrs: {
      "icon": "fa-caret-left"
    },
    on: {
      "click": _vm.showLess
    }
  }, [_vm._v("Back")]) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1275:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', {
    staticClass: "Err404"
  }, [_c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "conteneurerreur"
  }, [_c('div', {
    staticClass: "contenuerreur"
  }, [_c('div', {
    staticClass: "f2"
  }, [_vm._v("Oops!")]), _c('div', {
    staticClass: "f4 mt2"
  }, [_vm._v("We could not find the page you are looking for, sorry!")]), _c('div', {
    staticClass: "mb5 mt4"
  }, [_c('router-link', {
    staticClass: "historybtn",
    attrs: {
      "to": {
        name: 'hello'
      }
    }
  }, [_vm._v("Back to main menu")])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "backgroundimg"
  }), _c('div', {
    staticClass: "backgroundimgborder"
  }), _c('div', {
    staticClass: "behind"
  }, [_c('div', {
    staticClass: "contentsection"
  }, _vm._l((_vm.page.page_containers), function(p) {
    return _c('div', {
      staticClass: "menucontent fl flex"
    }, [_c('div', {
      staticClass: "menustyle"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'info-behind-show',
          params: {
            id: p.container.id
          }
        }
      }
    }, [_vm._v(_vm._s(p.container.titre))])], 1)])
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 1277:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "cd-transition-layer",
    class: {
      visible: _vm.isVisible
    }
  }), _c('div', {
    staticClass: "bgblackintro"
  }), _c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "animatedgradient"
  }), _c('div', {
    staticClass: "film"
  }, [_c('div', {
    staticClass: "logosection"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(739),
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "introsection"
  }, [_vm._v("Find out more about Dreaming of a Jewish Christmas, see the trailer, watch interview excerpts and read about the many people featured both on and off screen.")]), _c('hr', {
    staticClass: "lignemenu mt4"
  })]), _c('div', {
    staticClass: "contentsection ttu"
  }, [_c('div', {
    staticClass: "menucontent"
  }, [_c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "film/about"
    }
  }, [_vm._v("About the Film")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "film/interviews"
    }
  }, [_vm._v("Interviews")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "/film/about_team"
    }
  }, [_vm._v("About the Team")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "film/credits"
    }
  }, [_vm._v("Credits")])], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1278:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-vimeo"
  }, [(_vm.isVimeo(_vm.med.video.link)) ? _c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.valvid)
    }
  })]) : _c('div', [_c('q-video', {
    staticStyle: {
      "height": "25vw !important"
    },
    attrs: {
      "src": _vm.getVid(_vm.med.video.link)
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1279:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "about"
  }, [_c('q-btn', {
    directives: [{
      name: "back-to-top",
      rawName: "v-back-to-top.animate",
      value: ({
        offset: 500,
        duration: 200
      }),
      expression: "{offset: 500, duration: 200}",
      modifiers: {
        "animate": true
      }
    }],
    staticClass: "fixed-bottom-right animate-pop",
    staticStyle: {
      "margin": "0 30px 30px 0"
    },
    attrs: {
      "round": "",
      "color": "negative"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up fa-2x white"
  })]), _c('div', [_c('div', {
    staticClass: "bloctitre"
  }, [_vm._v("About The Team"), _c('hr'), _c('span', {
    staticClass: "f3"
  }, [_vm._v("behind Dreaming of a Jewish Christmas")])]), _vm._l((_vm.page.page_containers), function(p) {
    return _c('div', {
      staticClass: "containerabout flex"
    }, [_c('div', {
      staticClass: "imageabout"
    }, [(p.container.medias.length > 0) ? _c('img', {
      staticClass: "fl",
      attrs: {
        "src": p.container.medias[0].image.url
      }
    }) : _vm._e(), _c('div', {
      staticClass: "soustitreimageabout fl"
    }, [_vm._v(_vm._s(p.container.titre))])]), _c('div', {
      staticClass: "contenuabout"
    }, [_c('div', {
      staticClass: "fr",
      domProps: {
        "innerHTML": _vm._s(p.container.description)
      }
    })])])
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1280:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture",
    style: ({
      backgroundImage: ("url(" + _vm.image_background + ")")
    })
  }), _c('div'), _c('div', {
    staticClass: "info_show_song flex"
  }, [_c('Canvas-video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBack),
      expression: "showBack"
    }],
    ref: "videocan",
    staticStyle: {
      "z-index": "-9",
      "width": "100vw !important",
      "height": "137vh !important",
      "top": "-20vh !important",
      "position": "fixed !important"
    },
    attrs: {
      "src": _vm.video_background,
      "cover": true,
      "loop": true
    }
  }), _c('q-carousel', {
    ref: "infogene",
    attrs: {
      "infinite": "infinite",
      "no-swipe": "no-swipe"
    }
  }, [_c('div', {
    staticClass: "navigationsongs"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left historyarrowleft fa-3x-ns fa-2x",
    on: {
      "click": function($event) {
        _vm.checkSlide('previous')
      }
    }
  }), _c('i', {
    staticClass: "fa fa-arrow-right historyarrowright fa-3x-ns fa-2x",
    on: {
      "click": function($event) {
        _vm.checkSlide('next')
      }
    }
  })]), _c('div', {
    slot: "slide"
  }, [_c('img', {
    staticClass: "logosongs",
    attrs: {
      "src": _vm.data_tri[0].container.medias[0].image.url,
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "titrehistory flex mv3"
  }, [_c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  }), _c('div', {
    staticClass: "history white ttu mh3"
  }, [_vm._v("About the song")]), _c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  })]), _c('div', {
    staticClass: "introhistory",
    domProps: {
      "innerHTML": _vm._s(_vm.page.description)
    }
  }), _c('q-btn', {
    staticClass: "historybtn",
    attrs: {
      "label": "Open"
    },
    on: {
      "click": function($event) {
        _vm.openModalBasic()
      }
    }
  }, [_vm._v("Read more")])], 1), _c('div', {
    slot: "slide"
  }, [_c('img', {
    staticClass: "logosongs",
    attrs: {
      "src": _vm.data_tri[0].container.medias[0].image.url,
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "titrehistory flex mv3"
  }, [_c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  }), _c('div', {
    staticClass: "history white ttu mh3"
  }, [_vm._v("Songwriter")]), _c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  })]), _c('div', {
    staticClass: "introhistory",
    domProps: {
      "innerHTML": _vm._s(_vm.data_tri[1].container.description)
    }
  }), _c('q-btn', {
    staticClass: "historybtn",
    attrs: {
      "label": "Open"
    },
    on: {
      "click": function($event) {
        _vm.modalChanteur()
      }
    }
  }, [_vm._v("Read more")])], 1), _c('div', {
    slot: "slide"
  }, [_c('div', {
    staticStyle: {
      "z-index": "80",
      "top": "0"
    }
  }, [_c('img', {
    staticClass: "logosongs",
    attrs: {
      "src": _vm.data_tri[0].container.medias[0].image.url,
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "titrehistory flex mv3"
  }, [_c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  }), _c('div', {
    staticClass: "history white ttu mh3"
  }, [_vm._v("Song Recording")]), _c('hr', {
    staticClass: "white w-10 w-20-ns mh0"
  })]), _c('div', {
    staticClass: "introhistory",
    domProps: {
      "innerHTML": _vm._s(_vm.data_tri[4].container.description)
    }
  }), _c('q-btn', {
    staticClass: "historybtn",
    on: {
      "click": function($event) {
        _vm.modalSong()
      }
    }
  }, [_vm._v("play")])], 1)])]), _c('q-modal', {
    ref: "songModal",
    attrs: {
      "minimized": "minimized",
      "content-css": {
        padding: '-1px',
        background: 'transparent'
      }
    },
    on: {
      "close": function($event) {
        _vm.closeSong()
      }
    }
  }, _vm._l((_vm.data_tri[4].container.medias), function(med) {
    return (_vm.openSong) ? _c('div', [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.valvid)
      }
    })]) : _c('div', [_c('q-video', {
      staticStyle: {
        "width": "80vw",
        "height": "45vh"
      },
      attrs: {
        "src": _vm.getVid(med.video.link)
      }
    })], 1)]) : _vm._e()]) : _vm._e()
  })), _c('q-modal', {
    ref: "basicModal",
    attrs: {
      "minimized": "minimized",
      "content-css": {
        background: 'black',
        border: 'solid 2px white'
      }
    },
    on: {
      "close": function($event) {
        _vm.closeBasic()
      }
    }
  }, [_c('div', {
    staticClass: "bloctitre"
  }, [_vm._v(_vm._s(_vm.data_tri[2].container.titre))]), _vm._l((_vm.data_tri[2].container.medias), function(med) {
    return (_vm.openBasic) ? _c('div', {
      staticClass: "soustitre"
    }, [(med.image) ? _c('div', [_c('img', {
      attrs: {
        "src": med.image.url,
        "width": "90%",
        "height": "90%"
      }
    })]) : _vm._e()]) : _vm._e()
  }), _c('div', {
    staticClass: "blocdescription2"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.data_tri[2].container.description)
    }
  })]), _vm._l((_vm.data_tri[2].container.medias), function(med) {
    return (_vm.openBasic) ? _c('div', {
      staticClass: "soustitre"
    }, [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.valvid)
      }
    })]) : _c('div', [_c('q-video', {
      staticStyle: {
        "height": "300px"
      },
      attrs: {
        "src": _vm.getVid(med.video.link)
      }
    }), _c('p', [_vm._v(_vm._s(med.video.titre))])], 1)]) : _vm._e()]) : _vm._e()
  })], 2), _c('q-modal', {
    ref: "chanteurModal",
    attrs: {
      "minimized": "minimized",
      "content-css": {
        background: 'black',
        border: 'solid 2px white'
      }
    },
    on: {
      "close": _vm.closeChanteur
    }
  }, [_c('div', {
    staticClass: "bloctitre"
  }, [_vm._v(_vm._s(_vm.data_tri[3].container.titre))]), _c('div', {
    staticClass: "blocdescription2"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.data_tri[3].container.description)
    }
  })]), _vm._l((_vm.data_tri[3].container.medias), function(med) {
    return _c('div', {
      staticClass: "soustitre"
    }, [(med.image) ? _c('div', [_c('img', {
      attrs: {
        "src": med.image.url,
        "width": "90%",
        "height": "90%"
      }
    })]) : _vm._e()])
  }), _vm._l((_vm.data_tri[3].container.medias), function(med) {
    return (_vm.openChanteur) ? _c('div', {
      staticClass: "soustitre"
    }, [(med.video) ? _c('div', [(_vm.isVimeo(med.video.link)) ? _c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.valvid)
      }
    })]) : _c('div', [_c('q-video', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "src": _vm.getVid(med.video.link)
      }
    }), _c('p', [_vm._v(_vm._s(med.video.titre))])], 1)]) : _vm._e()]) : _vm._e()
  })], 2)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1281:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.crumbs && _vm.crumbs.length) ? _c('ul', {
    class: _vm.crumbClass
  }, _vm._l((_vm.crumbs), function(crumb, i) {
    return _c('li', [_c('router-link', {
      staticClass: "white hover-red b pointer",
      attrs: {
        "to": {
          path: crumb.url
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chevron-left fa-2x white"
    })])], 1)
  })) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "backgroundcolor"
  }), _c('div', {
    staticClass: "recipes overflow-x-hidden"
  }, [_c('div', {
    staticClass: "menucontent"
  }, [_c('div', {
    staticClass: "sectiontitre"
  }, [_c('span', {
    staticClass: "titretestintro"
  }, [_vm._v("THE "), _c('br')]), _c('span', {
    staticClass: "titretest"
  }, [_vm._v("RECIPES")]), _c('hr', {
    staticClass: "lignemenu mt4"
  })]), _c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carouselimages"
  }, _vm._l((_vm.container), function(recette) {
    return _c('div', {
      staticClass: "recettecard relative pointer"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'info-recipe-show',
          params: {
            id: recette.id,
            titre: recette.titre,
            image: recette.medias[0].image.url,
            description: recette.description
          }
        }
      }
    }, [_c('div', {
      staticClass: "recettetop"
    }, [_c('img', {
      staticClass: "imagerecette inset-shadow",
      attrs: {
        "src": recette.medias[0].image.url
      }
    })]), _c('div', {
      staticClass: "recettebottom"
    }, [_c('p', {
      staticClass: "recettetitre"
    }, [_vm._v(_vm._s(recette.titre))]), _c('i', {
      staticClass: "iconeplus fa fa-plus"
    })])])], 1)
  }))])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1283:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', {
    staticStyle: {}
  }, [_c('div', {
    staticClass: "cd-transition-layer",
    class: {
      visible: _vm.isVisible
    }
  }), _c('div', {
    staticClass: "bgblackintro"
  }), _c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "animatedgradient"
  }), _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "logosintro"
  }, [_c('div', {
    staticClass: "story fr"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'story'
      }
    }
  }, [_c('img', {
    staticClass: "logoresizing pb3",
    attrs: {
      "src": __webpack_require__(741)
    }
  })])], 1), _c('div', {
    staticClass: "song fr"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'songs'
      }
    }
  }, [_c('img', {
    staticClass: "logoresizing pb3",
    attrs: {
      "src": __webpack_require__(740)
    }
  })])], 1), _c('div', {
    staticClass: "film fr"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'film'
      }
    }
  }, [_c('img', {
    staticClass: "logoresizing pb3",
    attrs: {
      "src": __webpack_require__(739)
    }
  })])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1284:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', {
    staticClass: "overflow-x-hidden"
  }, [_c('div', {
    staticClass: "imgbackground"
  }), _c('div', {
    staticClass: "timeline pt5"
  }, [_c('q-btn', {
    directives: [{
      name: "back-to-top",
      rawName: "v-back-to-top.animate",
      value: ({
        offset: 500,
        duration: 200
      }),
      expression: "{offset: 500, duration: 200}",
      modifiers: {
        "animate": true
      }
    }],
    staticClass: "fixed-bottom-right animate-pop z-999",
    staticStyle: {
      "margin": "0 30px 30px 0"
    },
    attrs: {
      "round": "",
      "color": "negative"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up fa-2x white"
  })]), _vm._l((_vm.timelines), function(time) {
    return (_vm.timelines) ? _c('div', [_c('div', {
      staticClass: "titretimeline ttu"
    }, [_c('div', {
      staticClass: "white"
    }, [_vm._v("A timeline of songs and writers")])]), _vm._l((_vm.triTimeline(time.timeline_containers)), function(details, index) {
      return (index > 0) ? _c('div', {
        staticClass: "fulldatecontainer"
      }, [_c('div', {
        staticClass: "datecontainer"
      }, [_c('div', {
        staticClass: "animal"
      }, [_c('img', {
        attrs: {
          "src": details.zodiac
        }
      })]), _c('div', {
        staticClass: "date"
      }, [_c('span', {
        staticClass: "datenumber"
      }, [_vm._v(_vm._s(details.annee))])])]), _c('div', {
        staticClass: "secondarydates white"
      }, [_c('span', {
        staticClass: "pr1"
      }, [_vm._v("Hebraic year")]), _c('span', {
        staticClass: "pl1"
      }, [_vm._v(_vm._s(details.val[0].hebrew_year))])]), _c('div', {
        staticClass: "contenutimeline mb2 mt2 shadow-5"
      }, _vm._l((details.val), function(info, index) {
        return _c('div', [_c('h1', [_vm._v(_vm._s(info.container.titre))]), _c('p', {
          domProps: {
            "innerHTML": _vm._s(info.container.description)
          }
        }), _vm._l((info.container.medias), function(med) {
          return _c('div', {
            staticClass: "pt3"
          }, [(med.mediable_type === 'Image') ? _c('div', [(med.image.thumbnail) ? _c('img', {
            attrs: {
              "src": med.image.thumbnail,
              "width": "90%",
              "height": "90%"
            }
          }) : _vm._e(), _c('p', {
            staticClass: "descriptionimg",
            domProps: {
              "innerHTML": _vm._s(med.image.description)
            }
          })]) : _vm._e(), (med.mediable_type === 'Video') ? _c('div', [_c('video-vimeo', {
            attrs: {
              "med": med
            }
          })], 1) : _vm._e()])
        }), (info.container.tag_visibles.length > 0) ? _c('div', [_c('q-btn', {
          staticClass: "historybtn center",
          on: {
            "click": function($event) {
              _vm.goTo(info.container.tag_visibles[0].name)
            }
          }
        }, [_vm._v("Read more")])], 1) : _vm._e(), (details.val.length > 1 && index % 2 === 0) ? _c('hr', {
          staticClass: "lignestyle"
        }) : _vm._e()], 2)
      }))]) : _vm._e()
    })], 2) : _vm._e()
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1285:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "cd-transition-layer",
    class: {
      visible: _vm.isVisible
    }
  }), _c('div', {
    staticClass: "bgblackintro"
  }), _c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "animatedgradient"
  }), _c('div', {
    staticClass: "story"
  }, [_c('div', {
    staticClass: "logosection"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(741),
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "introsection"
  }, [_vm._v("Explore the background to Dreaming of a Jewish Christmas, including why many Jews celebrate the holiday with Chinese food, the history of Jews and Christmas, and a timeline of Jewish Christmas song writers and songs.")]), _c('hr', {
    staticClass: "lignemenu mt4"
  })]), _c('div', {
    staticClass: "contentsection"
  }, [_c('div', {
    staticClass: "menucontent ttu"
  }, [_c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "story/chow-mein"
    }
  }, [_vm._v("Why chow mein is the "), _c('br'), _vm._v(" chosen food")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "story/christmas"
    }
  }, [_vm._v("Can the jew keep christmas ?")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "story/timeline"
    }
  }, [_vm._v("A timeline of songs & songwriters")])], 1), _c('div', {
    staticClass: "menustyle2"
  }, [_c('router-link', {
    attrs: {
      "to": "story/recipes"
    }
  }, [_vm._v("Recipes")])], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1286:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', {
    staticStyle: {}
  }, [_c('div', {
    staticClass: "cd-transition-layer",
    class: {
      visible: _vm.isVisible
    }
  }), _c('div', {
    staticClass: "bgblackintro"
  }), _c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "animatedgradient"
  }), _c('div', {
    staticClass: "song"
  }, [_c('div', {
    staticClass: "menucontent"
  }, [_c('div', {
    staticClass: "sectiontitre"
  }, [_c('div', {
    staticClass: "logosection"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(740),
      "width": "200px"
    }
  }), _c('div', {
    staticClass: "introsection"
  }, [_vm._v("Learn the stories behind many of the most famous Christmas songs written by Jewish songwriters and listen to classic versions.")]), _c('hr', {
    staticClass: "lignemenu mt4"
  })])]), _c('div', {
    staticClass: "carousel"
  }, [_c('div', {
    staticClass: "carouselimages"
  }, _vm._l((_vm.container), function(chanson) {
    return _c('div', {
      staticClass: "songcard relative"
    }, [_c('div', {
      staticClass: "songtop"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'info-song-show',
          params: {
            id: chanson.id
          }
        }
      }
    }, [_c('img', {
      staticClass: "imagesong",
      attrs: {
        "src": _vm.imageFirstPos(chanson)
      }
    })])], 1)])
  }))])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1287:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('q-layout', {
    ref: "layout",
    staticClass: "layout",
    attrs: {
      "reveal": "reveal",
      "left-breakpoint": 4000
    }
  }, [(_vm.header && !_vm.home) ? _c('div', {
    staticClass: "header",
    slot: "header"
  }, [_c('div', {
    staticClass: "toolbar cf",
    staticStyle: {
      "background": "none !important"
    }
  }, [_c('q-btn', {
    staticClass: "menubtndroite fr",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.$refs.layout.toggleLeft()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-2x white"
  })]), _c('div', {
    staticClass: "breadcrumb"
  }, [_c('breadcrumb', {
    staticClass: "f6"
  })], 1)], 1)]) : _vm._e(), _c('q-scroll-area', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    slot: "left"
  }, [_c('i', {
    staticClass: "fa fa-close fa-2x white fr right-0 top-0 pa3 absolute pointer",
    on: {
      "click": function($event) {
        _vm.$refs.layout.toggleLeft()
      }
    }
  }), _c('q-list-header', {
    staticClass: "blocmenu w-100 flex justify-between items-center"
  }, [_c('div', {
    staticClass: "enhaut inset-shadow"
  }, [_c('img', {
    staticClass: "pt2 pointer",
    attrs: {
      "src": __webpack_require__(1252),
      "width": "250px"
    },
    on: {
      "click": function($event) {
        _vm.goTo()
      }
    }
  })]), _c('div', {
    staticClass: "aumilieu"
  }, [_c('div', {
    staticClass: "link pt3"
  }, [_c('q-side-link', {
    attrs: {
      "to": "/songs"
    }
  }, [_c('h1', [_vm._v("The songs")])])], 1), _c('div', {
    staticClass: "link"
  }, [_c('q-side-link', {
    attrs: {
      "to": "/story"
    }
  }, [_c('h1', [_vm._v("The story")])])], 1), _c('div', {
    staticClass: "link"
  }, [_c('q-side-link', {
    attrs: {
      "to": "/film"
    }
  }, [_c('h1', [_vm._v("The film")])])], 1)]), _c('div', {
    staticClass: "enbas"
  }, [_c('hr', {
    staticClass: "white w-50 mb3"
  }), _c('h2', [_vm._v("Watch the documentary on CBC, december 7th 9PM ET")]), _c('hr', {
    staticClass: "white w-50 mt3 mb3"
  }), _c('div', {
    staticClass: "socialicons inline"
  }, [_c('a', {
    staticClass: "social-icon",
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/pg/jewishxmasfilm"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook fa-2x white ph2"
  })]), _c('a', {
    staticClass: "social-icon",
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/jewishxmasfilm/"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x white ph2"
  })]), _c('a', {
    staticClass: "social-icon",
    attrs: {
      "target": "_blank",
      "href": "https://twitter.com/jewishxmasfilm"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-2x white ph2"
  })])]), _c('h3', [_vm._v("RIDDLE FILMS INC. © 2017")])])])], 1), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1288:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1289:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture"
  }), (_vm.container) ? _c('div', {
    staticClass: "credits"
  }, [_c('div', {
    staticClass: "bloctitre"
  }, [_vm._v(_vm._s(_vm.container.titre)), _c('hr', {
    staticClass: "mv1"
  }), _c('span', {
    staticClass: "f4"
  }, [_vm._v("Dreaming of a Jewish Christmas")])]), _vm._l((_vm.container.medias), function(med) {
    return _c('div', {
      staticClass: "soustitre"
    }, [(med.image) ? _c('div', [_c('img', {
      attrs: {
        "src": med.image.thumbnail,
        "width": "90%",
        "height": "90%"
      }
    })]) : _vm._e()])
  }), _c('div', {
    staticClass: "blocdescriptioncredits"
  }, [_c('div', {
    staticClass: "blocdecontenucredits",
    staticStyle: {
      "height": "85%",
      "overflow": "scroll"
    },
    attrs: {
      "id": "blocdecontenu"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.container.description)
    }
  }, [_c('q-fixed-position', {
    attrs: {
      "corner": "bottom-right",
      "offset": [18, 18]
    }
  }, [_c('q-btn', {
    directives: [{
      name: "back-to-top",
      rawName: "v-back-to-top.animate",
      value: ({
        offset: 50,
        duration: 200
      }),
      expression: "{offset: 50, duration: 200}",
      modifiers: {
        "animate": true
      }
    }],
    staticClass: "fa fa-arrow-up animate-pop",
    staticStyle: {
      "margin": "0 48% 100px 0"
    },
    attrs: {
      "round": "round",
      "color": "negative"
    },
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "id": "findescredits"
    }
  })])], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1294:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(745);
module.exports = __webpack_require__(744);


/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_quasar__ = __webpack_require__(579);


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    isMobile: function isMobile() {
      return __WEBPACK_IMPORTED_MODULE_0_quasar__["Platform"].is.mobile;
    },
    isDesktop: function isDesktop() {
      return __WEBPACK_IMPORTED_MODULE_0_quasar__["Platform"].is.desktop;
    }
  }
});

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1074)
}
var Component = __webpack_require__(19)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(1287),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The_Film_Button.b0ebe12.png";

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The_Songs_Button.5234b44.png";

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/The_Story_Button.e258bd5.png";

/***/ }),

/***/ 744:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setup_apollo__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__setup_vue__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_quasar__ = __webpack_require__(579);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





// import VueHead from 'vue-head'

// Vue.use(VueHead)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;



__WEBPACK_IMPORTED_MODULE_5_quasar__["default"].start(function () {
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    apolloProvider: __WEBPACK_IMPORTED_MODULE_3__setup_apollo__["a" /* apolloProvider */],
    render: function render(h) {
      return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
    }
  });
});

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hello__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_InfoShow__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_InfoShow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_InfoShow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Song__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Song___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Song__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Story__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Story___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Story__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Film__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Film___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Film__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Story_Timeline_vue__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Story_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Story_Timeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Story_Recipes__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Story_Recipes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Story_Recipes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Err404__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Err404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Err404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Film_Interview__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Film_Interview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Film_Interview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Film_About__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Film_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Film_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Film_Behind__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Film_Behind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Film_Behind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Song_Info__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Song_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Song_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Film_Credits__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Film_Credits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Film_Credits__);
















// import VueHead from 'vue-head'

// Vue.use(VueHead)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/menu',
    name: 'hello',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Hello___default.a
  }, {
    path: '/song/info/:id',
    name: 'info-song-show',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Song_Info___default.a,
    props: function props(_ref) {
      var params = _ref.params;
      return { id: String(params.id) };
    },
    meta: {
      breadcrumb: [{
        url: '/songs'
      }]
    }
  }, {
    path: '/info/:id',
    name: 'info-story-show',
    component: __WEBPACK_IMPORTED_MODULE_4__components_InfoShow___default.a,
    props: function props(_ref2) {
      var params = _ref2.params;
      return { id: String(params.id) };
    },
    meta: {
      breadcrumb: [{
        url: '/story'
      }]
    }
  }, {
    path: '/info/:id',
    name: 'info-film-show',
    component: __WEBPACK_IMPORTED_MODULE_4__components_InfoShow___default.a,
    props: function props(_ref3) {
      var params = _ref3.params;
      return { id: String(params.id) };
    },
    meta: {
      breadcrumb: [{
        url: '/film'
      }]
    }
  }, {
    path: '/info/:id',
    name: 'info-recipe-show',
    component: __WEBPACK_IMPORTED_MODULE_4__components_InfoShow___default.a,
    /*eslint-disable*/
    props: function props(_ref4) {
      var params = _ref4.params;
      return { id: String(params.id), titre: String(params.titre), image: String(params.image), description: String(params.description) };
    },
    /*eslint-enable*/
    meta: {
      breadcrumb: [{
        url: '/story/recipes'
      }]
    }
  }, {
    path: '/info/:id',
    name: 'info-interview-show',
    component: __WEBPACK_IMPORTED_MODULE_4__components_InfoShow___default.a,
    props: function props(_ref5) {
      var params = _ref5.params;
      return { id: String(params.id) };
    },
    meta: {
      breadcrumb: [{
        url: '/film/interviews'
      }]
    }
  }, {
    path: '/info/:id',
    name: 'info-behind-show',
    component: __WEBPACK_IMPORTED_MODULE_4__components_InfoShow___default.a,
    props: function props(_ref6) {
      var params = _ref6.params;
      return { id: String(params.id) };
    },
    meta: {
      breadcrumb: [{
        url: '/film'
      }]
    }
  }, {
    path: '/info/:id',
    name: 'info-about-show',
    component: __WEBPACK_IMPORTED_MODULE_4__components_InfoShow___default.a,
    props: function props(_ref7) {
      var params = _ref7.params;
      return { id: String(params.id) };
    },
    meta: {
      breadcrumb: [{
        url: '/film'
      }]
    }
  }, {
    path: '/songs',
    name: 'songs',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Song___default.a,
    meta: {
      breadcrumb: [{
        url: '/menu'
      }]
    }
  }, {
    path: '/story',
    name: 'story',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Story___default.a,
    meta: {
      breadcrumb: [{
        url: '/menu'
      }]
    }
  }, {
    path: '/story/chow-mein',
    name: 'chow-mein',
    component: __WEBPACK_IMPORTED_MODULE_4__components_InfoShow___default.a,
    props: function props(_ref8) {
      var params = _ref8.params;
      return { id: String('22369447-ad37-4443-bb26-37a9f3817009'), from: true };
    },
    meta: {
      breadcrumb: [{
        url: '/story'
      }]
    }
  }, {
    path: '/story/christmas',
    name: 'chris-jew',
    component: __WEBPACK_IMPORTED_MODULE_4__components_InfoShow___default.a,
    props: function props(_ref9) {
      var params = _ref9.params;
      return { id: String('b8d8f41b-dd74-4cb8-991f-a2b2da9e9f1c'), from: true };
    },
    meta: {
      breadcrumb: [{
        url: '/story'
      }]
    }
  }, {
    path: '/story/timeline',
    name: 'timeline',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Story_Timeline_vue___default.a,
    meta: {
      breadcrumb: [{
        url: '/story'
      }]
    }
  }, {
    path: '/story/recipes',
    name: 'recipes',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Story_Recipes___default.a,
    meta: {
      breadcrumb: [{
        url: '/story'
      }]
    }
  }, {
    path: '/film',
    name: 'film',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Film___default.a,
    meta: {
      breadcrumb: [{
        url: '/menu'
      }]
    }
  }, {
    path: '/film/behind',
    name: 'behind',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Film_Behind___default.a,
    meta: {
      breadcrumb: [{
        url: '/film'
      }]
    }
  }, {
    path: '/film/credits',
    name: 'creduts',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Film_Credits___default.a,
    meta: {
      breadcrumb: [{
        url: '/film'
      }]
    }
  }, {
    path: '/film/about_team',
    name: 'about_team',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Film_About___default.a,
    meta: {
      breadcrumb: [{
        url: '/film'
      }]
    }
  }, {
    path: '/film/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_4__components_InfoShow___default.a,
    props: function props(_ref10) {
      var params = _ref10.params;
      return { id: String('d4b8c2cf-68da-4a63-b263-ec6e9e2781ce'), from: 'film' };
    },
    meta: {
      breadcrumb: [{
        url: '/film'
      }]
    }
  }, {
    path: '/film/interviews',
    name: 'interview',
    props: function props(_ref11) {
      var params = _ref11.params;
      return { id: String(params.id) };
    },
    component: __WEBPACK_IMPORTED_MODULE_11__components_Film_Interview___default.a,
    meta: {
      breadcrumb: [{
        url: '/film'
      }]
    }
  }, {
    path: '*',
    name: 'errors',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Err404___default.a
  }]
});

router.afterEach(function (to, from, next) {
  if (window._satellite) {
    window._satellite.track('page view');
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphQLNetworkInterface; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apollo_client__ = __webpack_require__(585);







var GraphQLNetworkInterface = function (_HTTPFetchNetworkInte) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GraphQLNetworkInterface, _HTTPFetchNetworkInte);

  function GraphQLNetworkInterface() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GraphQLNetworkInterface);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GraphQLNetworkInterface.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GraphQLNetworkInterface)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GraphQLNetworkInterface, [{
    key: 'setUri',
    value: function setUri(uri) {
      // debugger
      this._uri = 'uri';
    }
  }]);

  return GraphQLNetworkInterface;
}(__WEBPACK_IMPORTED_MODULE_5_apollo_client__["b" /* HTTPFetchNetworkInterface */]);

/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export networkInterface */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apolloProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_client__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apollo__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setup_GraphQLNetworkInterface__ = __webpack_require__(779);




var networkInterface = new __WEBPACK_IMPORTED_MODULE_2__setup_GraphQLNetworkInterface__["a" /* GraphQLNetworkInterface */]('https://cbc.jackalope.technology/api/queries');

var apolloClient = new __WEBPACK_IMPORTED_MODULE_0_apollo_client__["a" /* default */]({
  networkInterface: networkInterface
});

/* unused harmony default export */ var _unused_webpack_default_export = (apolloClient);

var apolloProvider = new __WEBPACK_IMPORTED_MODULE_1_vue_apollo__["a" /* default */]({
  clients: {
    a: apolloClient
  },
  defaultClient: apolloClient
});

/***/ }),

/***/ 781:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apollo__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_quasar__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_canvasvideo__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_canvasvideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_canvasvideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_canvasvideo_dist_vuecanvasvideo_min_css__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_canvasvideo_dist_vuecanvasvideo_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_canvasvideo_dist_vuecanvasvideo_min_css__);


// import VueAnalytics from 'vue-analytics'
// Install the vue plugin
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_apollo__["a" /* default */]);
// Vue.use(VueAnalytics, {
//   id: 'UA-51154111-2',
//   // id: 'UA-110244204-1',
//   checkDuplicatedScript: true,
// })
__webpack_require__(1057);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_canvasvideo___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_quasar__["default"], {
  components: __WEBPACK_IMPORTED_MODULE_2_quasar__,
  directives: __WEBPACK_IMPORTED_MODULE_2_quasar__
});

/***/ }),

/***/ 782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_platformDetect__ = __webpack_require__(27);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Err404',
  data: function data() {
    return {
      container: null
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_platformDetect__["a" /* default */]],

  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout___default.a
  },
  methods: {}
});

/***/ }),

/***/ 784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_platformDetect__ = __webpack_require__(27);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['query containers_par_categorie($categorie: String!, $limit: Int, $page: Int){\n        containers_par_categorie(categorie: $categorie, limit: $limit){\n          id categorie_list description titre medias{\n            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}\n          }\n        }\n      }'], ['query containers_par_categorie($categorie: String!, $limit: Int, $page: Int){\n        containers_par_categorie(categorie: $categorie, limit: $limit){\n          id categorie_list description titre medias{\n            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}\n          }\n        }\n      }']);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Film',
  data: function data() {
    return {
      container: null,
      page: 1,
      showMoreEnabled: true,
      isVisible: true
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_platformDetect__["a" /* default */]],
  apollo: {
    container: {
      /*eslint-disable*/
      query: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return { categorie: 'film', limit: 4, page: this.page };
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.containers_par_categorie;
      },
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading: function watchLoading(isLoading, countModifier) {
        // isLoading is a boolean
        // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      }
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_3__components_shared_layout_BaseLayout___default.a
  },
  mounted: function mounted() {
    var body = document.getElementById('app');
    body.style.overflow = 'hidden';
    setTimeout(function () {
      // console.log('tete')
      this.isVisible = false;
      // console.log(this.isVisible)
      var temp = document.getElementsByClassName('cd-transition-layer');
      temp[0].style.visibility = 'hidden';
      temp[0].style.position = 'fixed';
    }, 3000);
  },

  methods: {
    showMore: function showMore() {
      var _this = this;

      if (this.page === 0) {
        this.page = 1;
      }
      this.page++;
      this.$apollo.queries.container.fetchMore({
        variables: {
          page: this.page
        },
        updateQuery: function updateQuery(previousResult, _ref) {
          var fetchMoreResult = _ref.fetchMoreResult;

          var newRes = fetchMoreResult.container;
          var hasMore = fetchMoreResult.container.total;
          if (hasMore > 4) {
            _this.showMoreEnabled = true;
          } else {
            if (hasMore > 4 * _this.page++) {
              _this.showMoreEnabled = true;
            } else {
              _this.showMoreEnabled = false;
            }
          }
          return {
            container: {
              container: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(previousResult.container), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newRes)),
              hasMore: hasMore
            }
          };
        }
      });
    }
  }
});

/***/ }),

/***/ 785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_platformDetect__ = __webpack_require__(27);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query page($id: String!){\n          page(id: $id){\n            id page_containers{\n              id container{titre id description titre medias{\n                id image{url description} position video{\n                  titre url description link\n                }\n              }} position\n            }\n          }\n      }'], ['query page($id: String!){\n          page(id: $id){\n            id page_containers{\n              id container{titre id description titre medias{\n                id image{url description} position video{\n                  titre url description link\n                }\n              }} position\n            }\n          }\n      }']);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'About',
  data: function data() {
    return {
      container: null,
      link: null,
      valvid: '',
      inter: '',
      page: 1,
      showMoreEnabled: true
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_platformDetect__["a" /* default */]],
  apollo: {
    page: {
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return { id: '0604efea-1686-4153-ad80-6d8131c7ad4f' };
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.page;
      }
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout___default.a
  },
  methods: {}
});

/***/ }),

/***/ 786:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_platformDetect__ = __webpack_require__(27);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query page($id: String!){\n          page(id: $id){\n            id page_containers{\n              id container{titre id}\n            }\n          }\n      }'], ['query page($id: String!){\n          page(id: $id){\n            id page_containers{\n              id container{titre id}\n            }\n          }\n      }']);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Behind',
  data: function data() {
    return {
      container: null,
      link: null,
      valvid: '',
      inter: '',
      page: 1,
      showMoreEnabled: true
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_platformDetect__["a" /* default */]],
  apollo: {
    page: {
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return { id: '0862c9f1-2919-4132-b05c-ed562d48bdc3' };
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.page;
      }
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout___default.a
  },
  methods: {}
});

/***/ }),

/***/ 787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_platformDetect__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_scrollto__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_scrollto__);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query container($id: String!){\n        container(id: $id){\n          id categorie_list description titre medias{\n            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}\n          }\n        }\n      }'], ['query container($id: String!){\n        container(id: $id){\n          id categorie_list description titre medias{\n            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}\n          }\n        }\n      }']);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Credits',
  data: function data() {
    return {
      container: null,
      link: null,
      valvid: '',
      thumbnail: '',
      open: false,
      resumeScroll: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_platformDetect__["a" /* default */]],
  mounted: function mounted() {
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_7_vue_scrollto___default.a.scrollTo('#findescredits', 50000, { container: '#blocdecontenu', easing: 'linear' });
    }, 2000);
  },
  apollo: {
    container: {
      /*eslint-disable*/
      query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return { id: 'faea436d-62b2-46a1-82e8-e8ab3409848d' };
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.container;
      },
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading: function watchLoading(isLoading, countModifier) {
        // isLoading is a boolean
        // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      }
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout___default.a
  },
  methods: {
    /*eslint-disable*/
    scrollToTop: function scrollToTop() {
      __WEBPACK_IMPORTED_MODULE_7_vue_scrollto___default.a.scrollTo('#findescredits', 5, { container: '#blocdecontenu', easing: 'linear', onCancel: function onCancel() {
          this.resumeScroll = true;
        } });
    },
    resume: function resume() {
      __WEBPACK_IMPORTED_MODULE_7_vue_scrollto___default.a.scrollTo('#findescredits', 5000, { container: '#blocdecontenu', easing: 'linear', onCancel: function onCancel() {
          this.resumeScroll = true;
        } });
    },

    /*eslint-enable*/
    getVid: function getVid(url) {
      if (url.includes('youtube')) {
        var link = url.replace(/(<([^>]+)>)/ig, '');
        /* eslint-disable */
        var re = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([\w\-]{10,12})(?:&feature)?(?:[\w\-]{0})?/g;
        var iframe = 'https://www.youtube.com/embed/$1';
        /* eslint-enable */
        link = iframe.replace('$1', link.split(re)[1]);
        // console.log(link)
        return link;
      } else {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://vimeo.com/api/oembed.json?url=' + url).then(function (response) {
          // console.log(response.data)
          var temp = response.data;
          // console.log(temp)
          // console.log('test')
          // console.log(temp)
          // console.log(temp.html)
          this.valvid = temp.html;
          return temp.html;
        });
      }
    },
    getHTML: function getHTML(url) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var h, w, temp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log('test')
                h = Math.round(document.documentElement.clientHeight * 0.5);
                w = Math.round(document.documentElement.clientWidth * 0.8);
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://vimeo.com/api/oembed.json?url=' + url + '&width=' + w + '&height=' + h);

              case 5:
                temp = _context.sent;

              case 6:
                _context.prev = 6;

                // console.log(temp.data.thumbnail_url_with_play_button)
                // console.log(temp.data.html)
                _this.valvid = temp.data.html;
                _this.thumbnail = temp.data.thumbnail_url_with_play_button;
                return _context.finish(6);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2,, 6, 10]]);
      }))();
    },

    isVimeo: function isVimeo(url) {
      if (url.includes('vimeo')) {
        this.getHTML(url);
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),

/***/ 788:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_platformDetect__ = __webpack_require__(27);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query page($id: String!){\n          page(id: $id){\n            id page_containers{\n              id container{titre id medias{\n                id video{\n                  url titre description link\n                }\n              }}\n            }\n          }\n      }'], ['query page($id: String!){\n          page(id: $id){\n            id page_containers{\n              id container{titre id medias{\n                id video{\n                  url titre description link\n                }\n              }}\n            }\n          }\n      }']);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Interview',
  data: function data() {
    return {
      container: null,
      link: null,
      valvid: '',
      inter: '',
      page: '',
      pageCurrent: 1,
      min: 5
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_platformDetect__["a" /* default */]],
  apollo: {
    page: {
      query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return { id: '863728d0-ed72-4be0-8e94-9fa3f3d70f18' };
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.page;
      }
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_5__components_shared_layout_BaseLayout___default.a
  },
  computed: {
    interviews: function interviews() {
      if (this.page.page_containers) {
        return this.page.page_containers;
      }
    },
    isMore: function isMore() {
      if (this.pageCurrent * this.min < this.page.page_containers.length) {
        return true;
      } else {
        return false;
      }
    },
    isLess: function isLess() {
      if (this.pageCurrent > 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    getHTML: function getHTML(url) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var h, w, temp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                h = Math.round(document.documentElement.clientHeight * 0.5);
                w = Math.round(document.documentElement.clientWidth * 0.8);
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://vimeo.com/api/oembed.json?url=' + url + '&width=' + w + '&height=' + h);

              case 5:
                temp = _context.sent;

              case 6:
                _context.prev = 6;

                _this.valvid = temp.data.html;
                _this.thumbnail = temp.data.thumbnail_url_with_play_button;
                return _context.finish(6);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2,, 6, 10]]);
      }))();
    },

    isVimeo: function isVimeo(url) {
      if (url.includes('vimeo')) {
        this.getHTML(url);
        return true;
      } else {
        return false;
      }
    },
    test: function test(interview) {
      this.inter = interview.container.medias[0].video.link;
      this.$refs.minimezedModal.open();
    },
    showMore: function showMore() {
      this.pageCurrent++;
    },
    showLess: function showLess() {
      this.pageCurrent--;
    },
    minListe: function minListe() {
      console.log('TEST');
      if (this.pageCurrent === 1) {
        return 1;
      } else {
        return this.pageCurrent * this.min - this.min + 1;
      }
    },
    maxListe: function maxListe() {
      if (this.pageCurrent === 1) {
        return 5;
      } else {
        console.log(this.pageCurrent * this.min);
        return this.pageCurrent * this.min;
      }
    }
  }
});

/***/ }),

/***/ 789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_platformDetect__ = __webpack_require__(27);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      containers: '',
      isVisible: true,
      date_de_diffusion: ''
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_platformDetect__["a" /* default */]],
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout___default.a
  },
  methods: {},
  mounted: function mounted() {
    var body = document.getElementById('app');
    body.style.overflow = 'hidden';
    setTimeout(function () {
      // console.log('tete')
      this.isVisible = false;
      // console.log(this.isVisible)
      var temp = document.getElementsByClassName('cd-transition-layer');
      temp[0].style.visibility = 'hidden';
      temp[0].style.position = 'fixed';
    }, 10000);
  }
});

/***/ }),

/***/ 790:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_platformDetect__ = __webpack_require__(27);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query containers_par_categorie($categorie: String!){\n        containers_par_categorie(categorie: $categorie){\n          id titre description medias{\n            id image{titre url description thumbnail} mediable_id mediable_type position video{titre link minutage description url}\n          }\n        }\n      }'], ['query containers_par_categorie($categorie: String!){\n        containers_par_categorie(categorie: $categorie){\n          id titre description medias{\n            id image{titre url description thumbnail} mediable_id mediable_type position video{titre link minutage description url}\n          }\n        }\n      }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query pages_par_categorie($categorie: String!, $limit: Int, $page: Int){\n        pages_par_categorie(categorie: $categorie, limit: $limit, page: $page){\n          id titre page_containers{\n            id position container{\n              id description titre medias{\n                image{\n                  url\n                }\n              }\n            }\n          }\n        }\n      }'], ['query pages_par_categorie($categorie: String!, $limit: Int, $page: Int){\n        pages_par_categorie(categorie: $categorie, limit: $limit, page: $page){\n          id titre page_containers{\n            id position container{\n              id description titre medias{\n                image{\n                  url\n                }\n              }\n            }\n          }\n        }\n      }']);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      containers_par_categorie: '',
      date_de_diffusion: ''
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_platformDetect__["a" /* default */]],
  apollo: {
    containers_par_categorie: {
      /*eslint-disable*/
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
      /*eslint-enable*/
      variables: function variables() {
        return { categorie: 'logo' };
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.containers_par_categorie;
      }
    },
    date_de_diffusion: {
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2),
      variables: function variables() {
        return { categorie: 'broadcast', limit: 40, page: 1 };
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.pages_par_categorie;
      },
      loadingKey: 'loading'
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout___default.a
  },
  methods: {
    checkUrl: function checkUrl(url) {
      // var temp = ''
    }
  },
  mounted: function mounted() {
    // var myvid = document.getElementById('video1')
    // myvid.play()
  }
});

/***/ }),

/***/ 791:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_platformDetect__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query container($id: String!){\n        container(id: $id){\n          id categorie_list description titre medias{\n            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}\n          }\n        }\n      }'], ['query container($id: String!){\n        container(id: $id){\n          id categorie_list description titre medias{\n            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}\n          }\n        }\n      }']);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfoShow',
  props: {
    id: { required: true },
    from: { required: false },
    titre: { required: false },
    image: { require: false },
    description: { require: false }
  },
  data: function data() {
    return {
      container: null,
      link: null,
      valvid: '',
      thumbnail: '',
      open: false,
      stripDesc: '',
      url: ''
    };
  },
  created: function created() {
    // alert('on cree la page')
    // this.$on('okHead', function () {
    //   console.log('test')
    // })
  },

  // head: {
  //   title: function () {
  //     return {
  //       inner: this.titre,
  //     }
  //   },
  //   meta: function () {
  //     console.log('on arrive')
  //     console.log(this.titre)
  //     console.log(this.image)
  //     var temp = this.description
  //     temp = temp.replace(/<br>/gi, '\n')
  //     temp = temp.replace(/<p.*>/gi, '\n')
  //     temp = temp.replace(/<a.*href="(.*?)".*>(.*?)<\/a>/gi, ' $2 (Link->$1) ')
  //     this.stripDesc = temp.replace(/<(?:.|\s)*?>/g, '')
  //     this.stripDesc = this.stripDesc.substr(0, 50)
  //     console.log(this.stripDesc)
  //     this.url = 'http://experience.dreamingofajewishchristmas.com/pages#' + this.$route.fullPath
  //     console.log(this.url)
  //     return [
  //       { name: 'description', content: this.stripDesc },
  //       { property: 'og:url', content: this.url },
  //       { property: 'og:type', content: 'article' },
  //       { property: 'og:title', content: this.titre, id: 'fb-title' },
  //       { property: 'og:description', content: this.stripDesc, id: 'fb-desc' },
  //       /*eslint-disable*/
  //       { property: 'og:image', content: '~@/assets/imgs_bg/fond10.jpg' },
  //       /*eslint-enable*/
  //     ]
  //   },
  // },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_platformDetect__["a" /* default */]],
  apollo: {
    container: {
      /*eslint-disable*/
      query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return { id: this.id };
      },
      skip: function skip() {
        return !this.id;
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.container;
      },
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading: function watchLoading(isLoading, countModifier) {
        // isLoading is a boolean
        // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      }
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout___default.a
  },
  methods: {
    getVid: function getVid(url) {
      if (url.includes('youtube')) {
        var link = url.replace(/(<([^>]+)>)/ig, '');
        /* eslint-disable */
        var re = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([\w\-]{10,12})(?:&feature)?(?:[\w\-]{0})?/g;
        var iframe = 'https://www.youtube.com/embed/$1';
        /* eslint-enable */
        link = iframe.replace('$1', link.split(re)[1]);
        // console.log(link)
        return link;
      } else {
        // axios.get('https://vimeo.com/api/oembed.json?url=' + url).then(function (response) {
        //   // console.log(response.data)
        //   var temp = response.data
        //   // console.log(temp)
        //   console.log('test')
        //   console.log(temp)
        //   console.log(temp.html)
        //   this.valvid = temp.html
        //   return temp.html
        // })
      }
    },
    getHTML: function getHTML(url) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var h, w, temp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log('test')
                h = Math.round(document.documentElement.clientHeight * 0.3);
                w = Math.round(document.documentElement.clientWidth * 0.72);
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://vimeo.com/api/oembed.json?url=' + url + '&width=' + w + '&height=' + h);

              case 5:
                temp = _context.sent;

              case 6:
                _context.prev = 6;

                console.log(temp.data.thumbnail_url_with_play_button);
                console.log(temp.data.html);
                _this.valvid = temp.data.html;
                _this.thumbnail = temp.data.thumbnail_url_with_play_button;
                return _context.finish(6);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2,, 6, 12]]);
      }))();
    },

    isVimeo: function isVimeo(url) {
      if (url.includes('vimeo')) {
        this.getHTML(url);
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),

/***/ 792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_platformDetect__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es__ = __webpack_require__(451);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query pages_par_categorie($categorie: String!, $limit: Int, $page: Int){\n        pages_par_categorie(categorie: $categorie, limit: $limit, page: $page){\n          id titre page_containers{\n            id position container{\n              id description titre medias{\n                image{\n                  url\n                }\n              }\n            }\n          }\n        }\n      }'], ['query pages_par_categorie($categorie: String!, $limit: Int, $page: Int){\n        pages_par_categorie(categorie: $categorie, limit: $limit, page: $page){\n          id titre page_containers{\n            id position container{\n              id description titre medias{\n                image{\n                  url\n                }\n              }\n            }\n          }\n        }\n      }']);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Song',
  data: function data() {
    return {
      container: null,
      page: 1,
      showMoreEnabled: true,
      isVisible: true,
      limit: 4
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_platformDetect__["a" /* default */]],
  apollo: {
    container: {
      /*eslint-disable*/
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return { categorie: 'songs_page', limit: 40, page: 1 };
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.pages_par_categorie;
      },
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading: function watchLoading(isLoading, countModifier) {
        // isLoading is a boolean
        // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      }
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout___default.a
  },
  mounted: function mounted() {
    var body = document.getElementById('app');
    body.style.overflow = 'hidden';
    setTimeout(function () {
      // console.log('tete')
      this.isVisible = false;
      // console.log(this.isVisible)
      var temp = document.getElementsByClassName('cd-transition-layer');
      temp[0].style.visibility = 'hidden';
      temp[0].style.position = 'fixed';
    }, 4000);
  },

  computed: {
    dataEnCours: function dataEnCours() {}
  },
  methods: {
    imageFirstPos: function imageFirstPos(chanson) {
      if (chanson.page_containers) {
        var temp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es__["b" /* orderBy */])(chanson.page_containers, ['position'], ['asc']);
        // console.log(temp[0])
        return temp[0].container.medias[0].image.url;
      }
    },
    stillData: function stillData() {
      if (this.page * 4 > this.container.length) {
        return false;
      } else {
        return true;
      }
    },
    showMore: function showMore() {
      this.page++;
    },
    showLess: function showLess() {
      this.page--;
    }
  }
});

/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_platformDetect__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es__ = __webpack_require__(451);




var _templateObject = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query page($id: String!){\n        page(id: $id){\n          id titre description page_containers{\n            id position container{\n              id description titre tag_visibles{\n                id name\n              } medias{\n                id position image{\n                  description titre url\n                } mediable_type video{\n                  description link minutage titre url\n                }\n              }\n            }\n          }\n        }\n      }'], ['query page($id: String!){\n        page(id: $id){\n          id titre description page_containers{\n            id position container{\n              id description titre tag_visibles{\n                id name\n              } medias{\n                id position image{\n                  description titre url\n                } mediable_type video{\n                  description link minutage titre url\n                }\n              }\n            }\n          }\n        }\n      }']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_taggedTemplateLiteral___default()(['query container($id: String!){\n        container(id: $id){\n          id categorie_list description titre medias{\n            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}\n          } tag_visibles{\n            id name\n          }\n        }\n      }'], ['query container($id: String!){\n        container(id: $id){\n          id categorie_list description titre medias{\n            id position image{titre url description thumbnail} mediable_id mediable_type video{titre link minutage description url}\n          } tag_visibles{\n            id name\n          }\n        }\n      }']);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InfoShow',
  props: {
    id: { required: true }
  },
  data: function data() {
    return {
      container: null,
      link: null,
      valvid: '',
      thumbnail: '',
      artiste: '',
      showBack: false,
      openBasic: false,
      openChanteur: false,
      openSong: false
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_platformDetect__["a" /* default */]],
  computed: {
    image_background: function image_background() {
      var temp = '';
      var find = false;
      if (this.data_tri) {
        for (var i = 0; i < this.data_tri.length; i++) {
          /*eslint-disable*/
          if (this.data_tri[i].container.tag_visibles.length > 0 && this.data_tri[i].container.tag_visibles[0].name === 'fono') {
            /*eslint-enable*/
            // console.log('trouvé')
            temp = this.data_tri[i].container.medias[0].image.url;
            // console.log(temp)
            find = true;
          }
        }
      }
      if (!find) {
        temp = '~@/../static/fond1.jpg';
      }
      return temp;
    },
    video_background: function video_background() {
      if (this.data_tri) {
        // console.log(this.data_tri[this.data_tri.length - 1])
        var temp = this.data_tri[this.data_tri.length - 1].container.description;
        temp = temp.replace(/<{1}[^<>]{1,}>{1}/g, '');
        return '~@/../static/video/videos_transitions/videos_background_songsrecording/' + temp;
      }
    },
    fiche_artiste: function fiche_artiste() {
      if (this.container) {
        // console.log(this.container)
        return this.container.tag_visibles[0].name;
      } else {
        return false;
      }
    },
    data_tri: function data_tri() {
      if (this.page) {
        // console.log(orderBy(this.page.page_containers, ['position'], ['asc']))
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es__["b" /* orderBy */])(this.page.page_containers, ['position'], ['asc']);
      }
    }
  },
  apollo: {
    page: {
      query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return { id: this.id };
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.page;
      }
    },
    container: {
      /*eslint-disable*/
      query: __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject2),
      variables: function variables() {
        return { id: this.id };
      },

      fetchPolicy: 'cache-first',
      skip: function skip() {
        return !this.id;
      },

      update: function update(data) {
        return data.container;
      },
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading: function watchLoading(isLoading, countModifier) {
        // isLoading is a boolean
        // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      }
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_4__components_shared_layout_BaseLayout___default.a
  },
  methods: {
    getVid: function getVid(url) {
      if (url.includes('youtube')) {
        var link = url.replace(/(<([^>]+)>)/ig, '');
        /* eslint-disable */
        var re = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([\w\-]{10,12})(?:&feature)?(?:[\w\-]{0})?/g;
        var iframe = 'https://www.youtube.com/embed/$1';
        /* eslint-enable */
        link = iframe.replace('$1', link.split(re)[1]);
        // console.log(link)
        return link;
      } else {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://vimeo.com/api/oembed.json?url=' + url).then(function (response) {
          // console.log(response.data)
          var temp = response.data;
          // console.log(temp)
          // console.log('test')
          // console.log(temp)
          // console.log(temp.html)
          this.valvid = temp.html;
          return temp.html;
        });
      }
    },
    getHTML: function getHTML(url) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var h, w, temp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log('test')
                h = Math.round(document.documentElement.clientHeight * 0.3);
                w = Math.round(document.documentElement.clientWidth * 0.72);
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get('https://vimeo.com/api/oembed.json?url=' + url + '&width=' + w + '&height=' + h);

              case 5:
                temp = _context.sent;

              case 6:
                _context.prev = 6;

                // console.log(temp.data.thumbnail_url_with_play_button)
                // console.log(temp.data.html)
                _this.valvid = temp.data.html;
                _this.thumbnail = temp.data.thumbnail_url_with_play_button;
                return _context.finish(6);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2,, 6, 10]]);
      }))();
    },

    isVimeo: function isVimeo(url) {
      if (url.includes('vimeo')) {
        this.getHTML(url);
        return true;
      } else {
        return false;
      }
    },
    showMusic: function showMusic() {},
    nextSlide: function nextSlide() {
      this.$refs.carous.next();
    },
    previousSlide: function previousSlide() {
      this.$refs.carous.previous();
    },
    checkSlide: function checkSlide(direction, vid) {
      if (direction === 'next') {
        if (this.$refs.infogene.slide === 1) {
          this.showBack = true;
          // this.$refs.videocan.showVideo = true
          this.$refs.videocan.play();
        } else {
          if (this.$refs.videocan.playing) {
            this.$refs.videocan.pause();
            this.$refs.videocan.setTime(0);
          }
          this.showBack = false;
        }
        this.$refs.infogene.next();
      } else if (direction === 'previous') {
        if (this.$refs.infogene.slide === 0) {
          this.showBack = true;
          // this.$refs.videocan.showVideo = true
          this.$refs.videocan.play();
        } else {
          if (this.$refs.videocan.playing) {
            this.$refs.videocan.pause();
            this.$refs.videocan.setTime(0);
          }
          this.showBack = false;
        }
        this.$refs.infogene.previous();
      }
    },
    closeMod: function closeMod() {
      // console.log('hey')
      this.$refs.videocan.play();
      this.$refs.songModal.close();
    },
    closeBasic: function closeBasic() {
      this.openBasic = false;
    },
    openModalBasic: function openModalBasic() {
      this.openBasic = true;
      this.$refs.basicModal.open();
    },
    closeChanteur: function closeChanteur() {
      this.openChanteur = false;
    },
    modalChanteur: function modalChanteur() {
      this.openChanteur = true;
      this.$refs.chanteurModal.open();
    },
    closeSong: function closeSong() {
      this.openSong = false;
      this.$refs.videocan.play();
    },
    modalSong: function modalSong() {
      this.openSong = true;
      this.$refs.videocan.pause();
      this.$refs.songModal.open();
    },
    continueVideo: function continueVideo() {
      this.$refs.videocan.play();
    }
  }
});

/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_platformDetect__ = __webpack_require__(27);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Story',
  data: function data() {
    return {
      container: null,
      page: 1,
      isVisible: true
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_platformDetect__["a" /* default */]],
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_0__components_shared_layout_BaseLayout___default.a
  },
  mounted: function mounted() {
    var body = document.getElementById('app');
    body.style.overflow = 'hidden';
    setTimeout(function () {
      // console.log('tete')
      this.isVisible = false;
      // console.log(this.isVisible)
      var temp = document.getElementsByClassName('cd-transition-layer');
      temp[0].style.visibility = 'hidden';
      temp[0].style.position = 'fixed';
    }, 4000);
  },

  methods: {
    test: function test() {
      // console.log('coucou')
      if (this.isVisible) {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
    }
  }
});

/***/ }),

/***/ 795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_platformDetect__ = __webpack_require__(27);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['query containers_par_categorie($categorie: String!, $limit: Int, $page: Int){\n        containers_par_categorie(categorie: $categorie, limit: $limit, page: $page){\n          id categorie_list description titre medias{\n            id position image{\n              titre url\n            }\n          }\n        }\n      }'], ['query containers_par_categorie($categorie: String!, $limit: Int, $page: Int){\n        containers_par_categorie(categorie: $categorie, limit: $limit, page: $page){\n          id categorie_list description titre medias{\n            id position image{\n              titre url\n            }\n          }\n        }\n      }']);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Recipes',
  data: function data() {
    return {
      container: null,
      page: 1,
      showMoreEnabled: true
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_platformDetect__["a" /* default */]],
  apollo: {
    container: {
      /*eslint-disable*/
      query: __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject),
      variables: function variables() {
        return { categorie: 'recette', limit: 4, page: this.page };
      },

      fetchPolicy: 'cache-first',
      update: function update(data) {
        return data.containers_par_categorie;
      },
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading: function watchLoading(isLoading, countModifier) {
        // isLoading is a boolean
        // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      }
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_3__components_shared_layout_BaseLayout___default.a
  },
  methods: {
    showMore: function showMore() {
      var _this = this;

      if (this.page === 0) {
        this.page = 1;
      }
      this.page++;
      this.$apollo.queries.container.fetchMore({
        variables: {
          page: this.page
        },
        updateQuery: function updateQuery(previousResult, _ref) {
          var fetchMoreResult = _ref.fetchMoreResult;

          var newRes = fetchMoreResult.container;
          var hasMore = fetchMoreResult.container.total;
          if (hasMore > 4) {
            _this.showMoreEnabled = true;
          } else {
            if (hasMore > 4 * _this.page++) {
              _this.showMoreEnabled = true;
            } else {
              _this.showMoreEnabled = false;
            }
          }
          return {
            container: {
              container: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(previousResult.container), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(newRes)),
              hasMore: hasMore
            }
          };
        }
      });
    }
  }
});

/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_VideoVimeo__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_shared_VideoVimeo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_shared_VideoVimeo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_platformDetect__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es__ = __webpack_require__(451);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query timelines{\n        timelines{\n          id description titre timeline_containers{\n            date date_format hebrew_year id options position container{\n              tag_visibles{\n                id name\n              } categorie_list description id titre medias{\n                id image{\n                  description titre thumbnail(dimension: "450x")\n                } mediable_id mediable_type position video{\n                  description link minutage titre url\n                }\n              }\n            }\n          }\n        }\n      }'], ['query timelines{\n        timelines{\n          id description titre timeline_containers{\n            date date_format hebrew_year id options position container{\n              tag_visibles{\n                id name\n              } categorie_list description id titre medias{\n                id image{\n                  description titre thumbnail(dimension: "450x")\n                } mediable_id mediable_type position video{\n                  description link minutage titre url\n                }\n              }\n            }\n          }\n        }\n      }']);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Timeline',
  props: {},
  data: function data() {
    return {
      timelines: null,
      valvid: '',
      urlvid: ''
    };
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_platformDetect__["a" /* default */]],
  apollo: {
    timelines: {
      /*eslint-disable*/
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
      update: function update(data) {
        return data.timelines;
      },
      fetchPolicy: 'cache-first',
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading: function watchLoading(isLoading, countModifier) {
        // isLoading is a boolean
        // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      }
    }
  },
  components: {
    BaseLayout: __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_BaseLayout___default.a,
    videoVimeo: __WEBPACK_IMPORTED_MODULE_3__components_shared_VideoVimeo___default.a
  },
  methods: {
    goTo: function goTo(adresse) {
      this.$router.push({ name: 'info-song-show', params: { id: adresse } });
    },

    triTimeline: function triTimeline(timeline) {
      var temp = [{ annee: '', val: [{}] }];
      var anneetemp = '';
      var index = 1;
      var animal = '';
      // console.log(timeline)
      // temp = orderBy(timeline, ['id'], ['asc'])
      // console.log(temp)
      for (var i = 0; i < timeline.length; i++) {
        anneetemp = timeline[i].date.substring(0, 4);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es__["a" /* findIndex */])(temp, { 'annee': anneetemp }) === -1) {
          var tab = [timeline[i]];
          /*eslint-disable*/
          if (anneetemp % 12 === 0) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvM3V5MmxkOGF1a19tb25rZXkucG5nIl1d/monkey.png?sha=9dd2f53ae120eabe';
          } else if (anneetemp % 12 === 1) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvOWtzeXhuN2E4c19yb29zdGVyLnBuZyJdXQ/rooster.png?sha=5511fa90e200705e';
          } else if (anneetemp % 12 === 2) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvMjZiNmN1b295dl9kb2cucG5nIl1d/dog.png?sha=8c3fe2d2676a936e';
          } else if (anneetemp % 12 === 3) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvMWpybHBzb3phbl9waWcucG5nIl1d/pig.png?sha=d2018ffc9ac29ce5';
          } else if (anneetemp % 12 === 4) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvMjg0ZXI4OTB2eV9yYXQucG5nIl1d/rat.png?sha=88da06ec324aded1';
          } else if (anneetemp % 12 === 5) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvOWI0ajYzYzhlYl9veC5wbmciXV0/ox.png?sha=331ce008a1c2a23f';
          } else if (anneetemp % 12 === 6) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvN2o1N201M2dmeV90aWdlci5wbmciXV0/tiger.png?sha=22e39f90e66530b3';
          } else if (anneetemp % 12 === 7) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvMjlwNGFhYTR5el9yYWJiaXQucG5nIl1d/rabbit.png?sha=05a1323e7599e1f3';
          } else if (anneetemp % 12 === 8) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvM29zZm1mbWptc19kcmFnb24ucG5nIl1d/dragon.png?sha=37563427c0b427a0';
          } else if (anneetemp % 12 === 9) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvNmt0bGVoNGIzMV9zbmFrZS5wbmciXV0/snake.png?sha=0cf0a4b545130064';
          } else if (anneetemp % 12 === 10) {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvNW5iN2ZyaWtpeV9ob3JzZS5wbmciXV0/horse.png?sha=c58a4d6fa56760a2';
          } else {
            animal = 'https://cbc.jackalope.technology/media/W1siZiIsIjIwMTcvMTEvMjkvNGU1ZGZnbzJ5cF9nb2F0LnBuZyJdXQ/goat.png?sha=5d6091bfea61b6e5';
          }
          /*eslint-enable*/
          temp[index] = { annee: anneetemp, val: tab, zodiac: animal };
          index++;
        } else {
          var indice = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es__["a" /* findIndex */])(temp, { 'annee': anneetemp });
          temp[indice].val.push(timeline[i]);
        }
      }
      return temp;
    }
  }
});

/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'videoVimeo',
  props: {
    med: { required: true }
  },
  data: function data() {
    return {
      valvid: '',
      urlvid: ''
    };
  },

  components: {},
  methods: {
    getVid: function getVid(url) {
      if (url.includes('youtube')) {
        var link = url.replace(/(<([^>]+)>)/ig, '');
        /* eslint-disable */
        var re = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?([\w\-]{10,12})(?:&feature)?(?:[\w\-]{0})?/g;
        var iframe = 'https://www.youtube.com/embed/$1';
        /* eslint-enable */
        link = iframe.replace('$1', link.split(re)[1]);
        return link;
      } else {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://vimeo.com/api/oembed.json?url=' + url).then(function (response) {
          var temp = response.data;
          this.valvid = temp.html;
          return temp.html;
        });
      }
    },
    getHTML: function getHTML(url) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var val, w, temp;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                val = '';
                w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

                w = Math.round(w / 2.25);
                // console.log(w / 1.50)
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://vimeo.com/api/oembed.json?url=' + url + '&width=' + w);

              case 6:
                temp = _context.sent;

              case 7:
                _context.prev = 7;

                val = temp.data.html;
                return _context.finish(7);

              case 10:
                _this.valvid = val;
                _this.urlvid = val.substring(13, 53);
                return _context.abrupt('return', val);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3,, 7, 10]]);
      }))();
    },

    isVimeo: function isVimeo(url) {
      if (url.includes('vimeo')) {
        this.getHTML(url);
        return true;
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_Breadcrumb__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_layout_Breadcrumb__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['query containers{\n        containers{\n          titre id\n        }\n      }'], ['query containers{\n        containers{\n          titre id\n        }\n      }']);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'baselayout',
  props: {
    header: { default: true },
    home: { required: false }
  },
  data: function data() {
    return {};
  },

  components: {
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_2__components_shared_layout_Breadcrumb___default.a
  },
  apollo: {
    containers: {
      /*eslint-disable*/
      query: __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject),
      fetchPolicy: 'cache-first',
      /*eslint-enable*/
      loadingKey: 'loading',
      watchLoading: function watchLoading(isLoading, countModifier) {
        // isLoading is a boolean
        // countModifier is either 1 or -1
        // console.log('EN CHARGEMENT', isLoading)
      }
    }
  },
  methods: {
    goTo: function goTo() {
      this.$router.push({ name: 'hello' });
      // console.log(this.$refs.layout)
      // this.$refs.layout.hideCurrentSide()
      // this.$refs.layout.toggleLeft()
      /* console.log(this.$refs.layout)
      this.$refs.layout.hideCurrentSide()
      this.$refs.layout.toggleLeft()
      console.log(this.$refs.layout) */
    },
    getPath: function getPath(id) {
      var temp = '/info/' + id;
      return temp;
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'breadcrumb',
  props: {
    crumbClass: {
      type: String,
      default: 'crumb'
    },
    homeIcon: {
      type: String,
      default: ''
    },
    rightIcon: {
      type: String,
      default: 'arrow-right'
    }
  },
  data: function data() {
    return {
      crumbs: null
    };
  },

  methods: {
    getBreadCrumb: function getBreadCrumb() {
      var route = this.$route;
      var router = this.$router;
      var currentpath = route.path.replace(/\//g, '');
      var parent = route.meta.parent;
      var crumbs = [];
      var routesArr = [];
      routesArr.push(route);
      while (parent && parent.length > 0) {
        var matched = router.match(parent);
        routesArr.unshift(matched);
        parent = matched.meta.parent || '';
      }
      for (var i = 0; i < routesArr.length; i++) {
        var breadcrumbs = routesArr[i].meta.breadcrumb;
        if (breadcrumbs && breadcrumbs.length > 0) {
          for (var j = 0; j < breadcrumbs.length; j++) {
            var crumbspath = (breadcrumbs[j].url || routesArr[i].path).replace(/\//g, '');
            var hidden = breadcrumbs[j].hidden;
            if (currentpath === crumbspath && !!hidden) {
              break;
            }
            crumbs.push(breadcrumbs[j]);
          }
        }
      }
      return crumbs;
    },
    changeBreadCrumb: function changeBreadCrumb() {
      this.crumbs = this.getBreadCrumb();
    }
  },
  watch: {
    $route: 'changeBreadCrumb'
  },
  mounted: function mounted() {
    this.changeBreadCrumb();
  }
});

/***/ })

},[1294]);


// WEBPACK FOOTER //
// static/js/app.b8f6c9473af7eb413f3f.js